import SinglePage, { H2, Paragraph } from "../single-page/single-page";
import { address, companyName, email } from "../../envs";
import { Helmet } from "react-helmet";

function PrivacyPolicy() {
    return (
        <SinglePage title="Polityka prywatności">
            <Helmet>
                <title>Polityka prywatności - {companyName}</title>
                <meta
                    name="description"
                    content="Zapoznaj się z naszą Polityką Prywatności, która opisuje zasady przetwarzania danych osobowych pozyskiwanych przez geoksiegi.pl zgodnie z RODO."
                />
                <meta
                    name="keywords"
                    content="Polityka prywatności, RODO, dane osobowe, geoksiegi.pl, bezpieczeństwo danych"
                />
            </Helmet>
            <div className="privacy-policy">
                <Paragraph>
                    Niniejsza Polityka Prywatności określa zasady przetwarzania danych osobowych pozyskiwanych przez <strong>geoksiegi.pl</strong> (dalej „Serwis”) zgodnie z obowiązującymi przepisami, w tym z Rozporządzeniem (UE) 2016/679 (RODO). Administratorem danych jest <strong>{companyName}</strong>, z siedzibą pod adresem: <strong>{address}</strong>, kontakt: <strong>{email}</strong>.
                </Paragraph>

                <H2>1. Informacje ogólne</H2>
                <Paragraph>
                    Serwis gromadzi dane osobowe użytkowników, które są niezbędne do świadczenia usług, w tym wyszukiwania numerów ksiąg wieczystych oraz realizacji transakcji, takich jak zakup pojedynczego numeru księgi wieczystej bez rejestracji lub pakietów dla zalogowanych użytkowników.
                </Paragraph>

                <H2>2. Jakie dane zbieramy?</H2>
                <Paragraph>W ramach korzystania z Serwisu możemy zbierać:</Paragraph>
                <ul>
                    <li>
                        - <strong>Dane identyfikacyjne:</strong> adres e-mail (podawane przy rejestracji lub podczas korzystania z usług).
                    </li>
                    <li>
                        - <strong>Dane płatnicze:</strong> informacje niezbędne do realizacji transakcji, takie jak dane do przetwarzania płatności.
                    </li>
                </ul>

                <H2>3. Cele przetwarzania danych</H2>
                <Paragraph>Dane osobowe przetwarzamy w następujących celach:</Paragraph>
                <ul>
                    <li>
                        - <strong>Świadczenie usług:</strong> umożliwienie wyszukiwania numerów ksiąg wieczystych oraz zakupu pojedynczego numeru (bez konieczności zakładania konta) lub korzystania z pakietów dla zalogowanych użytkowników.
                    </li>
                    <li>
                        - <strong>Realizacja transakcji:</strong> przetwarzanie płatności i wystawianie faktur.
                    </li>
                    <li>
                        - <strong>Wsparcie i kontakt:</strong> odpowiadanie na zapytania, udzielanie informacji oraz pomoc techniczna.
                    </li>
                    <li>
                        - <strong>Optymalizacja Serwisu:</strong> analiza statystyk i zachowań użytkowników w celu ulepszania naszych usług.
                    </li>
                </ul>

                <H2>4. Udostępnianie i przekazywanie danych</H2>
                <Paragraph>Twoje dane mogą być przekazywane:</Paragraph>
                <ul>
                    <li>
                        - <strong>Podmiotom współpracującym:</strong> firmom świadczącym usługi wspierające działanie Serwisu (np. operatorom płatności, firmom hostingowym) – wyłącznie w zakresie niezbędnym do realizacji usług.
                    </li>
                    <li>
                        - <strong>Organom publicznym:</strong> na podstawie obowiązujących przepisów prawa.
                    </li>
                </ul>
                <p>
                    Dane nie są sprzedawane ani przekazywane osobom trzecim w celach marketingowych.
                </p>

                <H2>5. Przechowywanie danych</H2>
                <Paragraph>
                    Dane osobowe przechowywane są przez okres niezbędny do realizacji celów, dla których zostały zebrane, lub przez okres wymagany przepisami prawa. Po upływie tego okresu dane zostaną usunięte lub zanonimizowane.
                </Paragraph>

                <H2>6. Pliki Cookies</H2>
                <Paragraph>
                    Serwis wykorzystuje pliki cookies oraz podobne technologie do celów analitycznych oraz ułatwienia korzystania z naszych usług. Użytkownik ma możliwość zmiany ustawień cookies w swojej przeglądarce. Szczegółowe informacje znajdują się w naszej Polityce Cookies.
                </Paragraph>

                <H2>7. Prawa użytkowników</H2>
                <Paragraph>Jako użytkownik masz prawo do:</Paragraph>
                <ul>
                    <li>- Dostępu do swoich danych osobowych.</li>
                    <li>- Ograniczenia przetwarzania danych lub wniesienia sprzeciwu wobec ich przetwarzania.</li>
                    <li>- Przenoszenia danych do innego administratora.</li>
                </ul>
                <Paragraph>
                    Aby skorzystać z powyższych praw, prosimy o kontakt na adres <strong>{email}</strong>.
                </Paragraph>

                <H2>8. Zmiany w Polityce Prywatności</H2>
                <Paragraph>
                    Serwis zastrzega sobie prawo do wprowadzania zmian w niniejszej Polityce Prywatności. Aktualna wersja polityki będzie zawsze dostępna na stronie Serwisu. Zachęcamy do regularnego zapoznawania się z jej treścią.
                </Paragraph>

                <H2>9. Kontakt</H2>
                <Paragraph>
                    Wszelkie pytania dotyczące niniejszej Polityki Prywatności lub przetwarzania Twoich danych osobowych prosimy kierować na adres: <strong>{email}</strong>.
                </Paragraph>
            </div>
        </SinglePage>
    );
}

export default PrivacyPolicy;
